import React from 'react';

export const ProgramSignupContext = React.createContext({ });

export const UserNotesContext = React.createContext({ });

export const NotificationContext = React.createContext({ });